<template src="../templates/grid-view.html" />

<script setup>

import { defineProps, computed, toRefs } from 'vue';
import { FavouriteIcon } from '@timezoneone/favourites';
import { showPublishDate, showCategory, categoryFilters } from '../../blog/config/config.js';

const props = defineProps({
    results: {
        type: Array,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: true,
    },
    categoriesFacets: {
        type: Array,
        required: true,
    },
});
const { results } = toRefs(props);

const favButtonCssClasses = ['button', 'favourites'];

const getCategoryName = computed(() => {

    return (categoryId) => {

        const category = categoryFilters.find((cat) => cat.category === categoryId);
        return category ? category.title : '';

    };

});

const scrollToIlMadeWrapper = () => {

    const element = document.getElementById('il-made-app');

    if (element) {

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - 16, behavior: 'smooth' });

    }

};

</script>
